import type { ViewportSettings } from '@/modules/settings/types/settings.types';
import { layout } from '@/shared/theme/tokens';

/** Defaults match historical hard-coded gate in AppProviders. */
export const DEFAULT_VIEWPORT_SETTINGS: ViewportSettings = {
  enabled: true,
  minWidth: layout.minAppWidth,
  minHeight: 0,
};

export function resolveViewportSettings(
  input?: Partial<ViewportSettings> | null
): ViewportSettings {
  const minWidth = Number(input?.minWidth);
  const minHeight = Number(input?.minHeight);
  return {
    enabled: typeof input?.enabled === 'boolean' ? input.enabled : DEFAULT_VIEWPORT_SETTINGS.enabled,
    minWidth:
      Number.isFinite(minWidth) && minWidth > 0
        ? Math.round(minWidth)
        : DEFAULT_VIEWPORT_SETTINGS.minWidth,
    minHeight:
      Number.isFinite(minHeight) && minHeight >= 0
        ? Math.round(minHeight)
        : DEFAULT_VIEWPORT_SETTINGS.minHeight,
  };
}

/** Auth / platform paths never show UnsupportedResolution. */
export function isViewportExemptPath(pathname: string): boolean {
  if (pathname === '/login' || pathname === '/forgot-password' || pathname === '/change-password') {
    return true;
  }
  if (pathname.startsWith('/reset-password')) return true;
  if (pathname.startsWith('/platform')) return true;
  return false;
}
